<div class="flex h-full">
  <div #scrollableContainerRef class="h-full flex-1 overflow-auto">
    <dojo-tiptap-editor-wrapper
      #editorWrapper
      class="h-full"
      [valueControl]="editorControl"
      [outputFormat]="TiptapEditorOutputFormat.Json"
      [editorOptions]="editorOptions()"
      [editable]="editable()"
      [slashMenuItems]="slashMenuItems"
      [scrollableParent]="scrollableContainer()"
      [contentPadding]="contentPadding()"
    />
  </div>

  @if (showTableOfContents() && editor(); as editor) {
    <div class="shrink-0 overflow-y-auto border-l border-neutral-200 p-3" style="width: 240px">
      <h3 class="mb-3 text-sm font-semibold text-gray-700">Table of Content</h3>
      <dojo-tiptap-table-of-contents
        [tableOfContentData]="tableOfContentsData()"
        [editor]="editor"
        [scrollableParent]="scrollableContainer()"
      />
    </div>
  }
</div>
